"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var Sizes = exports.Sizes = {
	none: process.env.REACT_APP_Sizes_none,
	xxs: process.env.REACT_APP_Sizes_xxs,
	xs: process.env.REACT_APP_Sizes_xs,
	sm: process.env.REACT_APP_Sizes_sm,
	md: process.env.REACT_APP_Sizes_md,
	lg: process.env.REACT_APP_Sizes_lg,
	xl: process.env.REACT_APP_Sizes_xl,
	xxl: process.env.REACT_APP_Sizes_xxl,
	xxxl: process.env.REACT_APP_Sizes_xxxl
};